export default "__VITE_ASSET__C3FBM9Qy__"